<i18n src="../../locales/lang.json"></i18n>

<template>
  <div :id="'divdrag'+el.CategoryId+'_'+parentcatsortid+'_'+parentcatid" class="card mx-0 px-0 skin shadow-1 rounded" style="background-color:inherit;" draggable="true" ondragstart="window.drag(event)" ondragend="window.dragend(event)" @drop.prevent="ondrop" ondragover="window.allowDrop(event)">
    <div class="card-header skin dark-bg py-2 custom-default-text" style="background-color:inherit">
      <div class="col-12 px-0">
        <div class="col-12 px-0">
          <h6 class="card-title pr-3">
            <i v-if="el.ParentId!==null" @click="getCategoryDetail(el.ParentId)" class="fa fa-arrow-left mr-1" aria-hidden="true"></i>
            <span class="overflowellipsis">{{el.CategoryName}}</span><span class="overflowellipsis"> ({{el.Files.length}})</span>
          </h6>
        </div>
      </div>
      <div v-if="(UserPermissionLevel>=el.WritePermissionLevel && el.WritePermissionLevel > 0) || UserPermissionLevel >= ADVANCED" class="pull-right" style="position: absolute;right: 0px;top: 10px; margin-right:7px; color: #aeaaaa">
        <div class="dropdown pull-right pr-2">
          <a href="#" class="list-icons-item caret-0 font-weight-bold" data-toggle="dropdown" style="color:inherit">
            <i class="icon-menu"></i>
          </a>
          <div class="skinnedmenu dropdown-menu dropdown-menu-right">
            <!--<a v-if="el.CategoryId > -1" v-bind:href="'javascript:editCategory('+el.CategoryId +',\'' +el.CategoryName +'\',\'' + el.Group +'\')'" class="dropdown-item">{{Lables[0]}} </a>-->
            <a v-if="el.CategoryId > -1" @click="editCategory(el.CategoryId,el.CategoryName,el.PermissionLevel, el.WritePermissionLevel, el.ModifyPermissionLevel)" class="dropdown-item">{{Lables[0]}} </a>
            <!--<a v-if="el.CategoryId > -1" v-bind:href="'javascript:addSubCategory('+el.CategoryId +')'" class="dropdown-item">{{Lables[7]}} </a>-->
            <a v-if="el.CategoryId > -1" @click="addSubCategory(el.CategoryId)" class="dropdown-item">{{Lables[7]}} </a>
            <!--<a v-if="el.IsGlobal == false" v-bind:href="'javascript:deleteCategory(' + el.CategoryId + ')'" class="dropdown-item">{{Lables[1]}}</a>-->
            <a v-if="el.IsGlobal == false" @click="deleteCategory(el.CategoryId,el.ParentId)" class="dropdown-item">{{Lables[1]}}</a>
            <!--<a v-bind:href="'javascript:uploadFile(' + el.CategoryId + ');'" class="dropdown-item">Upload File</a>-->
            <a @click="uploadFile(el.CategoryId)" class="dropdown-item">{{Lables[8]}}</a>
          </div>
        </div>
      </div>

    </div>
    <div class="card-body skin dark-bg pt-0" style="max-height:300px;overflow-y:auto">
      <div v-for="(file, index) in el.Files">
        <div v-if="!file.IsChildCategory" :id="'divdrag'+file.Id" class="row mb-1 white skin shadow-1 rounded py-2" style="" draggable="true" v-on:dragstart="ondragstart" ondragend="dragend(event)">
          <div class="col-10 px-0 pl-3" v-if="!file.IsChildCategory">
            <a style="color:inherit;cursor: pointer;" class="filelink" v-bind:onclick="'javascript:openFile('+'\'' +file.FileUrl+'\',\'' + file.FileName +'\')'">
              {{file.FileName}}
            </a>
            <span v-if="file.IsUpdated" class="badge badge-warning badge-pill" style="position:absolute;top:3px;right:10px">{{Lables[2]}}</span>
          </div>
          <div class="col-10 px-0 pl-3" v-if="file.IsChildCategory">
            <a style="color:inherit;cursor: pointer;" class="filelink" @click="loadChildCategory(file.ChildCategoryModel)">
              <i class="fa fa-folder mr-1" style="color: #9acd32;"></i>{{file.FileName}}
            </a>
          </div>
          <div v-if="((UserPermissionLevel>el.WritePermissionLevel && el.WritePermissionLevel > 0) || UserPermissionLevel >= ADVANCED) && !file.IsChildCategory" class="col-2 px-0 pr-2 leftorrightparent" style="color: #aeaaaa">

            <a href="#" style="margin-top:-10px;" class="list-icons-item caret-0 font-weight-bold pull-right" data-boundary="document" data-toggle="dropdown">
              <i class="icon-menu" style="margin-top:12px;"></i>
            </a>
            <div class="skinnedmenu dropdown dropdown-menu leftorright">
              <!--<a v-bind:href="'javascript:deleteFile('+ file.Id + ');'" class="dropdown-item">{{Lables[6]}}</a>-->
              <a @click="deleteFile(file.Id)" class="dropdown-item">{{Lables[6]}}</a>
              <a @click="editFile(file.Id,file.FileUrl,file.FileName)" data-boundary="viewport" class="dropdown-item">{{Lables[3]}} </a>
              <a v-bind:href="'javascript:fileReadLog(' + file.Id + ')'" class="dropdown-item">{{Lables[4]}}</a>
              <!--<div class="dropdown-submenu leftorright">
          <a href="#" class="dropdown-item dropdown-toggle dropdown-toggle-dynamic">{{Lables[5]}}</a>
          <div class="skinnedmenu dropdown-menu" style="max-height:300px;overflow-y:auto">
            <a v-for="(cat, index) in allcategories" class="dropdown-item" v-bind:href="'javascript:setcategory('+file.Id+','+cat.CategoryId+ ')'">{{cat.Name}}</a>
          </div>
        </div>-->
            </div>
          </div>
        </div>


        <div v-if="file.IsChildCategory" :id="'divdrag'+file.Id" class="row mb-1 white skin shadow-1 rounded py-2" style="" draggable="true" v-on:dragstart="ondragCatStart" ondragend="dragend(event)" @drop.prevent="ondrop" ondragover="window.allowDrop(event)">          
          <div class="col-10 px-0 pl-3" v-if="file.IsChildCategory">
            <a style="color:inherit;cursor: pointer;" class="filelink" @click="loadChildCategory(file.ChildCategoryModel)">
              <i class="fa fa-folder mr-1" style="color: rgb(180 188 188);"></i>{{file.FileName}}
            </a>
          </div>          
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "card-child-document",
    components: {
    },
    props: {
      el: {
        type: Object,
        default: {}
      },
      UserPermissionLevel: {
        type: Number,
        default: 0
      },
      parentcatid: {
        type: Number,
        default: 0
      },
      parentcatsortid: {
        type: Number,
        default: 0
      },
      ADVANCED: {
        type: Number,
        default: 0
      },
      Lables: {
        type: Array,
        default: []
      },
      allcategories: {
        type: Array,
        default: []
      },
    },
    data() {
      return {

      };
    },
    methods: {
      
      ondragstart() {
        if (this.UserPermissionLevel >= this.ADVANCED) {
          drag(event, 'fileMove', this);
        }
        
      },
      ondragCatStart() {
        if (this.UserPermissionLevel >= this.ADVANCED) {
          drag(event, 'subcatMove', this);
        }
        
      },
      ondrop(e) {
        if (this.UserPermissionLevel >= this.ADVANCED) {
          window.drop(e, 'DocuCategoryPage', this)
        }
        
      },
      loadCategory(id) {
        if (id > 0) {
          this.getCategoryDetail(id);
        } else {
          this.getCategoryDetail(this.el.CategoryId);
        }
      },

      editCategory(CategoryId, CategoryName, permissionLevel, writePermissionLevel, modifyPermissionLevel) {
        //eval("editCategory(CategoryId, CategoryName,Group)")
        //js function call
        editCategory(CategoryId, CategoryName, permissionLevel, this, writePermissionLevel, modifyPermissionLevel);
      },

      addSubCategory(CategoryId) {
        //js function call
        addSubCategory(CategoryId, this);
      },

      deleteCategory(CategoryId, ParentId) {
        //js function call
        deleteCategory(CategoryId, ParentId, this);
      },
      uploadFile(CategoryId) {
        //js function call
        uploadFile(CategoryId, this);
      },
      deleteFile(fileId) {
        //js function call
        deleteFile(fileId, this);
      },
      editFile(fileId, fileFileUrl, fileFileName) {
        //js function call
        editFile(fileId, fileFileUrl, fileFileName, this);
      },

      testing() {
        // destroy the vue listeners, etc
        //this.$destroy();

        // remove the element from the DOM
        //this.$el.parentNode.removeChild(this.$el);
        //this.$emit("testing", this);
      },
      getId() {
        return this._uid;
      },
      loadChildCategory(model) {
        console.log(model);
        this.el = model;
        this.getCategoryDetail(this.el.CategoryId);
      },
      async getCategoryDetail(catid) {
        if (catid === null) return;
        try {
          var url = "/api/FileCategory/v1/GetCategoryDetail?catid=" + catid;
          this.$http.get(url).then(async response => {
            this.el = response.data;
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
    },
    watch: {

    },
    mounted() {

    },
    computed: {

    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/document/card-child-document.vue